//二维数组去重
function merge(bigArray){
    let array =[] 
    const middeleArrary = bigArray.reduce((a,b)=>{
        return a.concat(b)
    });

    middeleArrary.forEach((arrItem)=>{
        if(array.indexOf(arrItem)==-1){
            array.push(arrItem)
        }
    })

    return array
}

module.exports={
    merge
}